import { CompactInput, PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import { Icon } from 'src/components/widgets/icon';
import ResetSolid from 'src/components/widgets/svg/resetSolid';
import { styled } from 'styled-components';

export const PropertiesPanelTextIcon = styled(Icon)`
    position: absolute;
    right: 10px;
    cursor: pointer;
    width: 16px;
`;

export type PropertiesPanelTextPropertyProps = {
    id: string;
    label: React.ReactNode;
    value: string;
    onChange?: (newValue: string, e?: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    reset?: boolean;
    initialValue?: string;
};
export const PropertiesPanelTextProperty: React.FC<PropertiesPanelTextPropertyProps> = ({ id, label, value, onChange, disabled, reset, initialValue }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <CompactInput id={`${id}-input`} type='text' value={value} onChange={(e) => onChange?.(e.target.value, e)} disabled={disabled} />
                {reset && (
                    <PropertiesPanelTextIcon
                        onClick={() => {
                            value = initialValue ?? '';
                            onChange?.(initialValue ?? '', undefined);
                        }}
                    >
                        <ResetSolid />
                    </PropertiesPanelTextIcon>
                )}
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
